import React, { useState } from 'react'
import moment from 'moment'

const formatDue = (date) => date && moment(date).isValid() ? moment(date).format('MMM D, YYYY') : '-'

const REASON_MAX_LENGTH = 1000

const ApprovalTasks = ({ tasks, isLoading, decidingTaskId, onDecision, onViewForms }) => {
    const taskList = Array.isArray(tasks) ? tasks : []

    // Task currently being rejected, and the reason typed so far. Only one rejection is open at a
    // time — the reason box replaces the row's actions until it is submitted or cancelled.
    const [rejectingTaskId, setRejectingTaskId] = useState(null)
    const [reason, setReason] = useState('')

    const closeReason = () => {
        setRejectingTaskId(null)
        setReason('')
    }

    const submitRejection = (tas_id) => {
        onDecision(tas_id, false, reason.trim())
        closeReason()
    }

    return (
    <section className="approval_tasks" aria-labelledby="approval-tasks-title">
        <div className="approval_tasks_header">
            <div><h3 id="approval-tasks-title">Approval tasks</h3><p>Items waiting for your review</p></div>
            <span className="approval_tasks_count">{taskList.length} pending</span>
        </div>
        <div className="approval_tasks_table_wrapper">
            {isLoading
                ? <div className="d-flex justify-content-center" style={{ padding: 20 }}>
                    <div className="spinner-border text-primary" role="status"><span className="sr-only">Loading...</span></div>
                </div>
                : <table className="approval_tasks_table">
                        <thead><tr><th>Task</th><th>Submitted by</th><th>Due</th><th>Forms</th><th><span className="sr-only">Actions</span></th></tr></thead>
                        <tbody>{taskList.map((task) => {
                            const formCount = task.prevTaskForms?.length || 0
                            const isDeciding = decidingTaskId === task.tas_id
                            const isRejecting = rejectingTaskId === task.tas_id
                            return (
                                <React.Fragment key={task.tas_id}>
                                <tr>
                                    <td>
                                        <strong>{task.tas_title}</strong>
                                        <small>{task.prev_tas_title ? `For: ${task.prev_tas_title}` : task.tas_description}</small>
                                    </td>
                                    <td>{task.prev_emp_name || '-'}</td>
                                    <td>{formatDue(task.tas_end_date)}</td>
                                    <td>
                                        {formCount > 0
                                            ? <button type="button" className="approval_task_view_forms" onClick={() => onViewForms(task)}>
                                                View {formCount} form{formCount > 1 ? 's' : ''}
                                            </button>
                                            : <span className="approval_tasks_status">No forms</span>}
                                    </td>
                                    <td className="approval_tasks_actions">
                                        <button
                                            type="button"
                                            className="approval_task_reject"
                                            disabled={isDeciding || isRejecting}
                                            onClick={() => { setRejectingTaskId(task.tas_id); setReason('') }}
                                        >Reject</button>
                                        <button
                                            type="button"
                                            className="approval_task_approve"
                                            disabled={isDeciding || isRejecting}
                                            onClick={() => onDecision(task.tas_id, true)}
                                        >Approve</button>
                                    </td>
                                </tr>
                                {isRejecting && <tr className="approval_task_reason_row">
                                    <td colSpan={5}>
                                        <label htmlFor={`reject-reason-${task.tas_id}`}>
                                            Reason for rejection <span aria-hidden="true">*</span>
                                        </label>
                                        <textarea
                                            id={`reject-reason-${task.tas_id}`}
                                            className="approval_task_reason_input"
                                            value={reason}
                                            maxLength={REASON_MAX_LENGTH}
                                            rows={3}
                                            autoFocus
                                            required
                                            placeholder="Tell the submitter what needs to change"
                                            onChange={(e) => setReason(e.target.value)}
                                        />
                                        <div className="approval_task_reason_actions">
                                            <span className="approval_task_reason_count">{reason.length}/{REASON_MAX_LENGTH}</span>
                                            <button type="button" className="approval_task_reason_cancel" onClick={closeReason}>Cancel</button>
                                            <button
                                                type="button"
                                                className="approval_task_reject"
                                                disabled={!reason.trim() || isDeciding}
                                                onClick={() => submitRejection(task.tas_id)}
                                            >Confirm rejection</button>
                                        </div>
                                    </td>
                                </tr>}
                                </React.Fragment>
                            )
                        })}</tbody>
                    </table>}
        </div>
    </section>
    )
}

export default ApprovalTasks
